<template>
  <v-dialog
    v-model="show"
    scrollable
    max-width="500px"
    width="90vw"
  >
    <v-card
      min-height="90vh"
    >
      <v-card-title class="d-flex align-center flex-nowrap">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              v-bind="attrs"
              v-on="on"
              color="primary"
              class="mr-3"
            >
              Departments
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense class="pa-2">
            <v-list-item>
              <v-checkbox
                dense
                hide-details
                label="All Departments"
                v-model="selectAllDepartments"
                @change="toggleAllDepartments"
              ></v-checkbox>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              v-for="dept in sortedActiveDepartments"
              :key="dept.Dep_ID"
            >
              <v-checkbox
                dense
                hide-details
                :label="dept.Dep_Name"
                v-model="selectedDepartments"
                :value="dept.Dep_ID"
                @change="updateDepartmentSelection"
              ></v-checkbox>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              outlined
              v-bind="attrs"
              v-on="on"
              color="primary"
              class="mr-3"
            >
              Labels
              <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list dense class="pa-2">
            <v-list-item>
              <v-checkbox
                dense
                hide-details
                label="All Labels"
                v-model="selectAllLabels"
                @change="toggleAllLabels"
              ></v-checkbox>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              v-for="label in sortedLabels"
              :key="label.Label_ID"
            >
              <v-checkbox
                dense
                hide-details
                :label="label.Label_Name"
                v-model="selectedLabels"
                :value="label.Label_ID"
                @change="updateLabelSelection"
              ></v-checkbox>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-text-field
          dense
          label="Search"
          v-model="search"
          append-icon="mdi-magnify"
          hide-details
          style="max-width: 200px;"
        ></v-text-field>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-subtitle class="d-flex">
        <v-checkbox
          dense
          hide-details
          label="Select All"
          v-model="selectAll"
          :indeterminate="isSomeFilteredEmployeeSelected"
          @change="toggleAllEmployee"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-checkbox
          dense
          hide-details
          label="Show Selected"
          v-model="showSelected"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-checkbox
          dense
          hide-details
          label="Show Deleted"
          v-model="showDeleted"
        ></v-checkbox>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text class="py-3">
        <v-data-table
          dense
          :search="search"
          :items="filteredEmployee"
          :headers="headers"
          :item-class="getItemClass"
          item-key="Employee_ID"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:[`item.Is_Selected`]="{ item }">
            <v-checkbox
              class="ma-0 pa-0"
              hide-details
              dense
              v-model="item.Is_Selected"
              @change="updateSelectedEmployeeList"
            ></v-checkbox>
          </template>
          <template v-slot:[`item.Labels`]="{ item }">
            <v-select
              v-model="item.Label_IDs"
              :items="labels"
              item-text="Label_Name"
              item-value="Label_ID"
              multiple
              dense
              hide-details
              chips
              small-chips
              flat
              solo
              @change="onEmployeeLabelsChange(item)"
            ></v-select>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          small
          outlined
          color="primary"
          @click="show = false"
        >
          cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          small
          color="primary"
          @click="updateListOfEmployee"
        >
          save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'EmployeeListSettingsDialog',
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search: '',
      selectedEmployee: [],
      headers: [
        {
          text: '',
          value: 'Is_Selected',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Full Name',
          value: 'Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        },
        {
          text: 'Labels',
          value: 'Labels',
          sortable: false,
          align: 'center',
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-no-wrap'
        }

      ],
      employee: [],
      showDeleted: false,
      showSelected: false,
      selectAll: false,
      departments: [],
      selectedDepartments: [],
      selectAllDepartments: true,
      labels: [],
      selectedLabels: [],
      selectAllLabels: true

    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    show: {
      get () {
        if (this.value) {
          this.getListOfEmployee()
          this.getDepartments()
          this.getLabels()
        }
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    activeDepartments () {
      return this.departments.filter(dept => dept.Is_Active)
    },
    sortedActiveDepartments () {
      return [...this.activeDepartments].sort((a, b) => a.Dep_Name.localeCompare(b.Dep_Name))
    },
    filteredEmployee () {
      let employees = this.employee

      if (!this.showDeleted) {
        employees = employees.filter(e => !e.Is_Deleted)
      }
      if (this.showSelected) {
        employees = employees.filter(e => e.Is_Selected)
      }
      if (this.search) {
        const keyword = this.search.toLowerCase()
        employees = employees.filter(e => e.Full_Name.toLowerCase().includes(keyword))
      }
      if (!this.selectAllDepartments) {
        if (this.selectedDepartments.length > 0) {
          employees = employees.filter(e => this.selectedDepartments.includes(e.Dep_ID))
        } else {
          return []
        }
      }

      if (!this.selectAllLabels) {
        if (this.selectedLabels.length > 0) {
          employees = employees.filter(e => {
            if (!e.Label_IDs) return false
            const employeeLabels = Array.isArray(e.Label_IDs)
              ? e.Label_IDs
              : e.Label_IDs.split(',').map(Number)
            return employeeLabels.some(labelId => this.selectedLabels.includes(labelId))
          })
        } else {
          return []
        }
      }

      return employees
    },
    isAllFilteredEmployeeSelected () {
      return this.filteredEmployee.length > 0 && this.filteredEmployee.length === this.filteredEmployee.filter(p => p.Is_Selected).length
    },
    isSomeFilteredEmployeeSelected () {
      const totalSelected = this.filteredEmployee.filter(p => p.Is_Selected).length
      return totalSelected > 0 && totalSelected < this.filteredEmployee.length
    },
    sortedLabels () {
      return [...this.labels].sort((a, b) => a.Label_Name.localeCompare(b.Label_Name))
    }
  },
  methods: {
    getDepartments () {
      this.axios.get('/api/get_departments_to_manage', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.departments = res.data
        this.selectedDepartments = this.activeDepartments.map(dept => dept.Dep_ID)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    toggleAllDepartments () {
      if (this.selectAllDepartments) {
        this.selectedDepartments = this.activeDepartments.map(dept => dept.Dep_ID)
      } else {
        this.selectedDepartments = []
      }
    },
    updateDepartmentSelection () {
      this.selectAllDepartments = this.selectedDepartments.length === this.activeDepartments.length
    },
    updateSelectedEmployeeList () {
      this.selectedEmployee = this.employee.filter(e => e.Is_Selected).map(e => e.Employee_ID)
      if (this.selectedEmployee.length === this.employee.length) {
        this.selectAll = true
      }
    },
    getItemClass (item) {
      return item.Is_Deleted ? 'warning lighten-5' : ''
    },
    getListOfEmployee () {
      this.axios.get('/api/employee-list-cmp', {
        headers: { Authorization: 'Bearer ' + this.user.token }
      }).then(res => {
        this.employee = res.data.map(e => ({
          ...e,
          Label_IDs: e.Label_IDs ? e.Label_IDs.split(',').map(id => Number(id)) : []
        }))
        this.updateSelectedEmployeeList()
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    updateListOfEmployee () {
      const employeeSelections = this.employee.map(e => ({
        Employee_ID: e.Employee_ID,
        Is_Selected: e.Is_Selected
      }))

      const labelAssignments = this.employee
        .filter(e => e.LabelsChanged)
        .map(e => ({
          Employee_ID: e.Employee_ID,
          Labels: e.Label_IDs.join(',')
        }))

      this.axios.post('/api/update-employee-settings-bulk', {
        employeeSelections: employeeSelections,
        labelAssignments: labelAssignments
      }, {
        headers: { Authorization: 'Bearer ' + this.user.token }
      }).then(() => {
        this.$store.dispatch('setSuccess', {
          successMsg: 'Employee settings successfully updated'
        })
        this.show = false
        this.$emit('updateEmployeeList')
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    toggleAllEmployee () {
      this.filteredEmployee.forEach(e => {
        e.Is_Selected = this.selectAll
      })
      this.updateSelectedEmployeeList()
    },
    getLabels () {
      this.axios.get('/api/project_employee_labels', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.labels = res.data
        this.selectedLabels = this.labels.map(label => label.Label_ID)
        this.selectAllLabels = true
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    toggleAllLabels () {
      if (this.selectAllLabels) {
        this.selectedLabels = this.labels.map(label => label.Label_ID)
      } else {
        this.selectedLabels = []
      }
    },
    updateLabelSelection () {
      this.selectAllLabels = this.selectedLabels.length === this.labels.length
    },
    onEmployeeLabelsChange (employee) {
      employee.LabelsChanged = true
    }
  },
  watch: {
    isAllFilteredEmployeeSelected (newVal) {
      if (newVal !== this.selectAll) {
        this.selectAll = newVal
      }
    }
  }
}
</script>
